module.exports = __webpack_public_path__ + "img/camera-blue.9c9208fc.svg";